<template>
  <div class="wrapper">
    <div class="log_bg">
      <div>
        <img src="../../assets/images/logo.jpg" alt="">
      </div>
      <div class="success">
        恭喜您，注册成功
      </div>
      <div class="qcode">
        <div>
          <img src="../../assets/images/qrcode.jpg" alt="">
        </div>
        <div>
          欲了解更多精彩直播内容，<br/>请关注2020CMDHRA直播平台。
        </div>
      </div>

      <div class="todetails">
        <a :href="url">点击观看直播</a>

      </div>
    </div>



  </div>
</template>
<script>
  export default {
    data() {
      return {
        url:"",
      }
    },
    props: {},
    methods: {},
    computed: {},
    mounted() {
      //http://medical.medcircle.cn/illumina/details?type=live&liveId=147
      let url= window.location.href
      if(url.includes('medical.medcircle.cn')){
        this.url = 'http://medical.medcircle.cn/illumina_pc/';//生产环境

      }else if(url.includes('www.medcircle.top')){
        this.url = 'http://www.medcircle.top/illumina_pc/';//测试环境
      }else{
        this.url = 'http://192.168.2.252:8080/illumina_pc/';//测试环境
      }
    }
  }
</script>
<style scoped lang="scss">
  .wrapper{
    background: url("../login/img/loginBg.png") no-repeat;
    background-size: 100%;
    padding-top: 20px;
    height: 100vh;
    overflow: hidden;
    box-sizing: border-box;
  }
  .log_bg{
    width: 600px;
    min-height: 600px;
    padding-top: 20px;
    /*background: url("../../assets/images/meBg.png") no-repeat;*/
    /*-webkit-background-size: 100%;*/
    background-size: 100%;
    box-sizing: border-box;
    border: 1px solid #cccccc;
    margin: 0px auto;

    >div{
      width: 600px;
      text-align: center;
      >img{
        /*width: 3.8rem;*/
        /*margin-top: 1.33rem ;*/
      }
    }
    .success{
      text-align: center;
      color: #FFB441;
      font-size: 18px;
      margin-top: 20px;
      margin-bottom: 30px;
    }
    .qcode{
      font-size: 16px;
      text-align: center;
      width: 250px;
      /*height: 250px;*/
      margin: 0 auto;
      >div{
        width:250px;
        /*margin: 0 auto 0.24rem;*/
      }
      >div:nth-of-type(1){
        background: url("../../assets/images/border1.png") no-repeat;
        -webkit-background-size: 100%;
        background-size: 100%;
        height: 270px;
        img{
          width: 200px;
          margin-top: 20px;
        }
      }

      >div:nth-of-type(2){

      }
    }
    .todetails{
      width: 250px;
      height: 60px;
      background:#FFB441;
      color: #FFFFFF;
      font-size: 18px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      line-height:60px;
      margin: 20px auto 20px;
      a{
        color: #FFFFFF !important;
        width: 100%;
        height: 100%;
        display: inline-block;
        border-radius: 5px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/container/activeInfo_pc.vue